import { Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { ChoosePlanLinkProps } from './types';

export const ChoosePlanLink: React.FC<ChoosePlanLinkProps> = ({ text }) => {
  const externalUrls = useSelector(
    (state: RootState) => state.resources.externalUrls,
  );
  const handleExternalUrl = () => {
    const url = window.location.origin;
    return `${url}/educator/premium/choosePlan`;
  };
  return (
    <Typography
      component={Link}
      to={handleExternalUrl()}
      target="_blank"
      sx={{
        textDecoration: 'none',
        color: '#1976d2',
        fontWeight: 'inherit',
        fontSize: 'inherit',
      }}
    >
      {text}
    </Typography>
  );
};
